module.exports = __webpack_public_path__ + "img/moni.06072c85.png";